import { render, staticRenderFns } from "./SystemsList.vue?vue&type=template&id=65a4e8ee"
import script from "./SystemsList.vue?vue&type=script&lang=js"
export * from "./SystemsList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/mnt/disk1/buildAgent/work/8268df4d62037a26/vAnalyticsJS/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('65a4e8ee')) {
      api.createRecord('65a4e8ee', component.options)
    } else {
      api.reload('65a4e8ee', component.options)
    }
    module.hot.accept("./SystemsList.vue?vue&type=template&id=65a4e8ee", function () {
      api.rerender('65a4e8ee', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "js/modules/admin/components/Systems/SystemsList.vue"
export default component.exports